import BaseValidator from "./BaseValidator";

const salesTaxValidator = Object.create(BaseValidator);

salesTaxValidator.validateAgainstRegex = /^(19,0|7,0)$/;

export default salesTaxValidator.init();
